import { clearAnonymization } from 'app/shared/helpers/clearAnonymization';
import { getCapitalized } from 'app/shared/helpers/getCapitalized';
import { InputControlProps } from 'app/components/Controls/InputControl/InputControl.interfaces';

const MAX_STREET_NAME_LENGTH = 120;

export function formatValue(value: string) {
  const trimmed = value.replace(/ +(?= )/g, '').trim();
  return getCapitalized(trimmed);
}

export function useStreetNameControl({
  input,
  onValueChange,
}: InputControlProps) {
  const handleChange = (value: string) => {
    if (value.length > MAX_STREET_NAME_LENGTH) {
      return false;
    }

    input.onChange(value);

    if (onValueChange) {
      onValueChange(value, false, false);
    }

    return true;
  };

  const handleFocus = (value: string) => {
    const clearedValue = clearAnonymization(value);

    if (clearedValue !== value) {
      input.onChange(clearedValue);
      if (onValueChange) {
        onValueChange(clearedValue, false, false);
      }
    }
  };

  const handleBlur = (value: string) => {
    const formattedValue = formatValue(value);

    if (formattedValue !== input.value) {
      input.onChange(formattedValue);
    }
  };

  return {
    handleChange,
    handleFocus,
    handleBlur,
  };
}
